import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Sync.css';
import { useState, useEffect } from 'react';
import client from './utils/sanity/client.ts';
import BlockContent from "@sanity/block-content-to-react";
import SoundCloudPlayer from './SoundCloudPlayer';
import Modal from "./Modal";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function Sync() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [syncs, setSyncs] = useState([])

  useEffect(() => {
    client.fetch(`*[_type == "sync"] {
          title,
          style,
          slug,
          body,
          link,
          mainImage {
            asset -> {
              _id,
              url
            },
            alt,
          }
        }`)
      .then((data) => {
        setSyncs(data);
      })
      .catch(console.error);

  }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState(null);

  const handleTrackClick = (track) => {
    console.log('Clicked track URL:', track.url);
    setSelectedTrack(track);
    setModalOpen(true);

  };

  const closeModal = () => {
    setSelectedTrack(null);
    setModalOpen(false);
  };


  return (
    <div className='sync-container'>
      <Helmet>
        <title>Sync Page</title>
        <meta name="description" content="Aethel has genres of material available for sync licensing. If interested, you can contact her and she will respond via email." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Sync Page - Aethel Music" />
        <meta property="og:description" content="Aethel has genres of material available for sync licensing. If interested, you can contact her and she will respond via email." />
        <meta property="og:image" content="%PUBLIC_URL%/images/warriorprincessMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/sync" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sync Page - Aethel Music" />
        <meta name="twitter:description" content="Aethel has genres of material available for sync licensing. If interested, you can contact her and she will respond via email." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/warriorprincessMedium.png" />
      </Helmet>
      <h1 className="sync-heading">Sync Licensing</h1>
      <p className="sync-body-text">Æthel's ethereal sound is suited to a variety of contexts. She has a range of songs and pieces for sync-licensing use.
        <br />They come complete with sound stems and instrumentals for ease of use.</p>

      <div className='sync-music-container'>
        {syncs.map((sync) => (

          <div key={sync.slug} className='category-container'>
            <h2 className='sync-titles'>{sync.title}</h2>
            <h3 className='sync-style'>Genre: {sync.style}</h3>
            <LazyLoadImage src={sync.mainImage.asset.url} alt={sync.title} effect="blur" />
            <div>
              <BlockContent
                blocks={sync.body}
                projectId="pcafmc1n"
                dataset="production"
                className="sync-block-content"
              />
            </div>
            <button onClick={() => handleTrackClick({ title: sync.title, url: sync.link })}>Listen</button>

          </div>
        ))}

      </div>

      <Modal isOpen={modalOpen} onClose={closeModal} imageUrl={selectedTrack?.imageUrl} name={selectedTrack?.title} />

      {
        selectedTrack && (
          <div id='soundcloud-embed' className='soundcloud selected'>
            <SoundCloudPlayer
              key={selectedTrack.title}
              trackUrl={selectedTrack.url}
              trackTitle={selectedTrack.title}
              isSelected={true}
              onToggle={closeModal}
              width="60%"
              height="500px"
            />
          </div>
        )
      }
      <Link to="/contact" id='contact-button'><button id='sync-btn'>Enquire Now</button></Link>
    </div >
  );
}
